import { reactive } from "vue";

let messages = reactive([]);

const guidGenerator = () =>  {
    const S4 = () => (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
};

const timeouts = [];

export default {
    get messages() {
        return messages;
    },

    add({title, message, type, level}) {
        const id = guidGenerator();

        if (level === 'danger') {
            type = 'error';
        }

        messages.push({id, title, message, type});
        this.addTimeout(id);
    },

    addTimeout(id) {
        timeouts[id] = setTimeout(() => this.remove({id}), 5000);
    },

    removeTimeout(id) {
        clearTimeout(timeouts[id]);
    },

    success(title, message) {
        this.add({ title, message, type: "success" });
    },
    error(title, message) {
        this.add({ title, message, type: "error" });
    },
    warning(title, message) {
        this.add({ title, message, type: "warning" });
    },

    remove(message) {
        const index = messages.findIndex(({id}) => id === message.id);
        if (index === -1) { return; }
        messages.splice(index, 1);
    }
}
